import { fechFromBPartsApi } from '../utils';

const saveUserCars = async ({
  locale,
  car_identifier,
  csrftoken,
}: {
  locale: string;
  car_identifier: string;
  csrftoken: string;
}) => {
  const data = await fechFromBPartsApi(
    `/${locale}/shop/user_cars/${encodeURI(car_identifier)}`,
    {
      method: 'PUT',
      headers: new Headers([
        ['Content-Type', 'application/json'],
        ['X-CSRFToken', csrftoken],
      ]),
      credentials: 'include',
    },
      );

  return data.json();
};

export default saveUserCars;
